import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=20f3d60e&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=20f3d60e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3d60e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvatarImage: require('/opt/buildhome/repo/components/global/Avatar/AvatarImage.vue').default})
